import isNumber from 'lodash/isNumber'

export const reduceReactsPerMoment = (state: Record<string, number>, action: { momentId: string }) => {
  const momentId = action.momentId

  if (isNumber(state[momentId])) {
    state[momentId]++
  } else {
    state[momentId] = 1
  }

  return state
}

export const TAPS_BEFORE_TELL_YOU_PROMPT = 6
